module.exports = __webpack_public_path__ + "img/GAME_SEAOFFANTASY2.0fd5c2c7.jpg";